import { ReduxControls } from "rhombus-react";

import { PLATFORMS, SOCIAL_AD_TYPES, SOCIAL_FORMATS } from "utils/constants";
import { mapFacebookStringToOption, normalizeOptionToString } from "social/utils";

export const FORMAT_SELECT_INDEX = 0;
export const ADD_CONTENT_INDEX = 1;

export const ADTYPE_LABELS = {
	[SOCIAL_AD_TYPES.FACEBOOK_IMAGE]: "Image",
	[SOCIAL_AD_TYPES.FACEBOOK_VIDEO]: "Video",
	[SOCIAL_AD_TYPES.FACEBOOK_CAROUSEL]: "Carousel",
	[SOCIAL_AD_TYPES.FACEBOOK_IMAGE_MO]: "Image",
	[SOCIAL_AD_TYPES.FACEBOOK_VIDEO_MO]: "Video",
	[SOCIAL_AD_TYPES.FACEBOOK_CAROUSEL_MO]: "Carousel",
	[SOCIAL_AD_TYPES.GOOGLE_DEMAND_GEN_IMAGE]: "Demand Gen Image",
	[SOCIAL_AD_TYPES.GOOGLE_DEMAND_GEN_CAROUSEL]: "Demand Gen Carousel",
	[SOCIAL_AD_TYPES.LINKEDIN_IMAGE]: "Sponsored Image",
	[SOCIAL_AD_TYPES.LINKEDIN_VIDEO]: "Sponsored Video",
	[SOCIAL_AD_TYPES.LINKEDIN_CAROUSEL]: "Sponsored Carousel",
	[SOCIAL_AD_TYPES.PINTEREST_IMAGE]: "Image Pin",
	[SOCIAL_AD_TYPES.PINTEREST_VIDEO]: "Video Pin",
	[SOCIAL_AD_TYPES.PINTEREST_MAX_WIDTH_VIDEO]: "Max Width Video",
	[SOCIAL_AD_TYPES.PINTEREST_CAROUSEL]: "Carousel",
	[SOCIAL_AD_TYPES.SNAPCHAT_IMAGE]: "Web View Image",
	[SOCIAL_AD_TYPES.SNAPCHAT_VIDEO]: "Web View Video",
	[SOCIAL_AD_TYPES.TWITTER_IMAGE]: "Image Website Card",
	[SOCIAL_AD_TYPES.TWITTER_VIDEO]: "Video Website Card",
	// [SOCIAL_AD_TYPES.TWITTER_CAROUSEL]: "Website Carousel",
	[SOCIAL_AD_TYPES.YOUTUBE_INSTREAM]: "Video",
	[SOCIAL_AD_TYPES.YOUTUBE_DISCOVERY]: "TrueView Discovery",
	[SOCIAL_AD_TYPES.TIKTOK_VIDEO]: "In-Feed Video Ad",
};

export const FACEBOOK_DSP_INTERNAL_NAME = "facebook";
export const FACEBOOK_MO_DSP_INTERNAL_NAME = "facebook_mo";
export const GOOGLE_DSP_INTERNAL_NAME = "google_discovery_mo";
export const YOUTUBE_DSP_INTERNAL_NAME = "youtube";
export const LINKEDIN_DSP_INTERNAL_NAME = "linkedin_mo";
export const SNAPCHAT_DSP_INTERNAL_NAME = "snap_mo";
export const TWITTER_DSP_INTERNAL_NAME = "twitter_mo";
export const PINTEREST_DSP_INTERNAL_NAME = "pinterest_mo";
export const TIKTOK_DSP_INTERNAL_NAME = "tiktok_mo";

export const PLATFORM_BY_DSP_INTERNAL_NAME = {
	[FACEBOOK_DSP_INTERNAL_NAME]: PLATFORMS.FACEBOOK,
	[FACEBOOK_MO_DSP_INTERNAL_NAME]: PLATFORMS.FACEBOOK_MO,
	[GOOGLE_DSP_INTERNAL_NAME]: PLATFORMS.GOOGLE,
	[YOUTUBE_DSP_INTERNAL_NAME]: PLATFORMS.YOUTUBE,
	[LINKEDIN_DSP_INTERNAL_NAME]: PLATFORMS.LINKEDIN,
	[SNAPCHAT_DSP_INTERNAL_NAME]: PLATFORMS.SNAPCHAT,
	[TWITTER_DSP_INTERNAL_NAME]: PLATFORMS.TWITTER,
	[PINTEREST_DSP_INTERNAL_NAME]: PLATFORMS.PINTEREST,
	[TIKTOK_DSP_INTERNAL_NAME]: PLATFORMS.TIKTOK,
};

export const TWITTER_CONVERSATION_CONTROL_OPTIONS = [
	{
		label: "Everyone",
		value: "Everyone",
	},
	{
		label: "Following",
		value: "Following",
	},
	{
		label: "Mentioned Users",
		value: "Mentioned Users",
	},
];

export const PAC_FORM_TYPES = {
	DEFAULT: "Default",
	SQUARE: "Square",
	VERTICAL: "Vertical",
	HORIZONTAL: "Horizontal",
	REELS: "Reels",
};
export const PAC_FORM_TYPES_LIST = Object.values(PAC_FORM_TYPES);

export const PAC_TYPES = {
	NONE: "none",
	ASPECT_RATIO: "aspectRatio",
	PLACEMENT: "placement",
};

export const PAC_TYPE_LABELS = {
	[PAC_TYPES.ASPECT_RATIO]: "Aspect Ratio",
	[PAC_TYPES.PLACEMENT]: "Placement",
};

export const facebookPagesTextProps = {
	component: ReduxControls.Input,
	normalize: mapFacebookStringToOption,
	format: normalizeOptionToString,
	placeholder: "Enter Facebook Page id",
};

export const instagramTextProps = {
	component: ReduxControls.Input,
	normalize: mapFacebookStringToOption,
	format: normalizeOptionToString,
	placeholder: "Enter Instagram account id",
};

export const MAX_CAROUSEL_CARDS_BY_ADTYPE = {
	[SOCIAL_AD_TYPES.FACEBOOK_CAROUSEL]: 10,
	[SOCIAL_AD_TYPES.FACEBOOK_CAROUSEL_MO]: 10,
	[SOCIAL_AD_TYPES.GOOGLE_DEMAND_GEN_CAROUSEL]: 10,
	[SOCIAL_AD_TYPES.PINTEREST_CAROUSEL]: 5,
	[SOCIAL_AD_TYPES.TWITTER_CAROUSEL]: 6,
	[SOCIAL_AD_TYPES.LINKEDIN_CAROUSEL]: 10,
};

export const ALLOWED_CARD_TYPES_BY_ADTYPE = {
	[SOCIAL_AD_TYPES.FACEBOOK_CAROUSEL]: [
		SOCIAL_FORMATS.IMAGE,
		SOCIAL_FORMATS.VIDEO
	],
	[SOCIAL_AD_TYPES.FACEBOOK_CAROUSEL_MO]: [
		SOCIAL_FORMATS.IMAGE,
		SOCIAL_FORMATS.VIDEO
	],
	[SOCIAL_AD_TYPES.PINTEREST_CAROUSEL]: [
		SOCIAL_FORMATS.IMAGE
	],
	[SOCIAL_AD_TYPES.TWITTER_CAROUSEL]: [
		SOCIAL_FORMATS.IMAGE,
		SOCIAL_FORMATS.VIDEO
	],
	[SOCIAL_AD_TYPES.LINKEDIN_CAROUSEL]: [
		SOCIAL_FORMATS.IMAGE
	],
};

export const FACEBOOK_PAC_BY_ADTYPE = {
	[SOCIAL_AD_TYPES.FACEBOOK_CAROUSEL]: [
		PAC_FORM_TYPES.DEFAULT,
		PAC_FORM_TYPES.HORIZONTAL,
		PAC_FORM_TYPES.SQUARE,
		PAC_FORM_TYPES.VERTICAL,
	],
	[SOCIAL_AD_TYPES.FACEBOOK_CAROUSEL_MO]: [
		PAC_FORM_TYPES.DEFAULT,
		PAC_FORM_TYPES.HORIZONTAL,
		PAC_FORM_TYPES.SQUARE,
		PAC_FORM_TYPES.VERTICAL,
		PAC_FORM_TYPES.REELS
	],
	[SOCIAL_AD_TYPES.FACEBOOK_IMAGE]: [
		PAC_FORM_TYPES.DEFAULT,
		PAC_FORM_TYPES.HORIZONTAL,
		PAC_FORM_TYPES.SQUARE,
		PAC_FORM_TYPES.VERTICAL,
	],
	[SOCIAL_AD_TYPES.FACEBOOK_IMAGE_MO]: [
		PAC_FORM_TYPES.DEFAULT,
		PAC_FORM_TYPES.HORIZONTAL,
		PAC_FORM_TYPES.SQUARE,
		PAC_FORM_TYPES.VERTICAL,
		PAC_FORM_TYPES.REELS
	],
	[SOCIAL_AD_TYPES.FACEBOOK_VIDEO]: [
		PAC_FORM_TYPES.DEFAULT,
		PAC_FORM_TYPES.HORIZONTAL,
		PAC_FORM_TYPES.SQUARE,
		PAC_FORM_TYPES.VERTICAL,
	],
	[SOCIAL_AD_TYPES.FACEBOOK_VIDEO_MO]: [
		PAC_FORM_TYPES.DEFAULT,
		PAC_FORM_TYPES.HORIZONTAL,
		PAC_FORM_TYPES.SQUARE,
		PAC_FORM_TYPES.VERTICAL,
		PAC_FORM_TYPES.REELS
	],
};

export const GOOGLE_ASPECT_RATIO_LABELS = {
	[SOCIAL_AD_TYPES.GOOGLE_DEMAND_GEN_CAROUSEL]: {
		square: "Square (YouTube Mobile)",
		horizontal: "Horizontal (YouTube Mobile)",
		vertical: "Vertical (Discover)",
	},
	[SOCIAL_AD_TYPES.GOOGLE_DEMAND_GEN_IMAGE]: {
		square: "Square (Gmail Mobile)",
		horizontal: "Horizontal (Gmail Mobile)",
		vertical: "Vertical (Gmail Mobile)",
	},
};

/* Disabled Features Messages Versions*/
export const UNEDITABLE_DYNAMIC_VARIABLE_MESSAGE = "Dynamic variables cannot be modified for creatives that have versions. Please remove non-default versions if you would like to change dynamic variables.";
export const UNEDITABLE_CARD_MESSAGE = "Cards cannot be added or removed once the creative has versions";
export const UNEDITABLE_CARD_ASSET_TYPE_MESSAGE = "Card types cannot be edited once the creative has versions";
